import tickIcon from "assets/images/icons/tick.png";
// import { Fade } from "react-awesome-reveal";

const Features = () => {
  // data
  let featuresData = [
    {
      title: `Get real, lasting results quickly`,
      desc: `You’ll immediately begin to feel the benefits after just your
    first session`,
    },
    {
      title: `Learn to be a mindful parent`,
      desc: `Deal with your kids’ challenging behavior with love, empathy &
    patience`,
    },
    {
      title: `Raise happier kids`,
      desc: `Your children will benefit from your patience, calmness, & happiness`,
    },
    {
      title: `Enjoy motherhood more`,
      desc: `Prioritize your mental and emotional wellbeing and feel like
    yourself again`,
    },
  ];
  return (
    <div className="features_wrapper">
      {/* <Fade
        key={index}
        direction="up"
        triggerOnce
        delay={750 + (index + 100)}
        duration={1400}
      > */}
      {featuresData?.map((item, index) => (
        <div key={index} className="feature_box d_flex">
          <div className="feature_icon">
            <img src={tickIcon} alt="" />
          </div>
          <div className="feature_content">
            <h5>{item?.title}</h5>
            <p>{item?.desc}</p>
          </div>
        </div>
      ))}
      {/* </Fade> */}
    </div>
  );
};

export default Features;
